var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "ci-card p-3 p-md-4 p-xl-5" }, [
    _c("div", { staticClass: "row mx-0" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "col-12 col-md-7 pl-0 pl-md-4 align-self-center" },
        [
          _c("div", [
            _c("h2", { staticClass: "h3" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "ui.views.social_events.index.value_proposition.heading_1"
                  )
                )
              ),
            ]),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("ui.views.social_events.index.value_proposition.text_1")
              )
            ),
          ]),
          _c("p", { staticClass: "font-weight-bolder" }, [
            _vm._v(
              _vm._s(
                _vm.$t("ui.views.social_events.index.value_proposition.text_2")
              )
            ),
          ]),
          _c(
            "div",
            { staticClass: "d-flex flex-wrap" },
            [
              _c("ci-button", {
                staticClass: "to-sign-in mr-md-3",
                attrs: {
                  variant: "outline-primary",
                  to: { path: "/users/sign_in" },
                  label: _vm.$t(
                    "ui.views.social_events.index.value_proposition.to_sign_in"
                  ),
                },
              }),
              _c("ci-button", {
                staticClass: "to-sign-up mb-3 mb-md-0",
                attrs: {
                  variant: "filled-primary",
                  to: {
                    path: "/users/sign_up",
                    query: { onboarding_type: "social-events" },
                  },
                  label: _vm.$t(
                    "ui.views.social_events.index.value_proposition.to_sign_up"
                  ),
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "col-12 col-md-5 px-0 align-self-center" },
      [
        _c("img", {
          staticClass: "img-responsive mb-4 mb-md-0 w-100",
          attrs: {
            src: require("@frontend/assets/images/kongress.jpg"),
            alt: "CAPinside Kongress",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }